"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Loader_1 = require("./Loader");
exports.default = Loader_1.default;
//# sourceMappingURL=index.js.map